import { IGameConfig, ISgSdk, ISgSdkCommands, ISgSdkHandler, SgSdkModules } from "./types";

type InitializeOptions = Pick<
  ISgSdkCommands,
  "runGame" | "supportedLanguages" | "freezeGame" | "unfreezeGame" | "startOver" | "getScore"
>;

declare const sgSdk: ISgSdk;

export default function initialize(options: InitializeOptions): Promise<{
  config: IGameConfig;
  handler: ISgSdkHandler; 
}> {
  return new Promise((resolve, reject) => {
    sgSdk.initialize(
      [SgSdkModules.BASIC, SgSdkModules.SCOREGAME],
      {
        // @ts-ignore
        id: __GAMEID__,
        // @ts-ignore
        build: __BUILD__,
        ...options,
      },
      (error, settings, handler) => {
        if (error) {
          reject(error);
          return;
        }

        const { config } = settings;
        resolve({ config, handler });
      }
    );
  });
}
